import { useState, useCallback } from 'react';
import { NewsList } from './components/NewsList';
import { NewsDetail } from './components/NewsDetail';
import { TopBanner } from './components/TopBanner';
import { AppHeader } from './components/AppHeader';
import { AppFooter } from './components/AppFooter';
import { useNewsByCategory } from './hooks/useGNews';
import { useCategory } from './hooks/useCategory';
import type { NewsItem } from './types/news';
import './App.css';
import './styles/themes.css';

function App() {
  const [selectedNews, setSelectedNews] = useState<NewsItem | null>(null);
  const { selectedCategory, setSelectedCategory } = useCategory();
  const newsQuery = useNewsByCategory(selectedCategory);

  const handleNewsClick = useCallback((news: NewsItem) => {
    setSelectedNews(news);
  }, []);

  const handleBack = useCallback(() => {
    setSelectedNews(null);
  }, []);

  const handleCategoryChange = useCallback((category: typeof selectedCategory) => {
    setSelectedNews(null);
    setSelectedCategory(category);
  }, [setSelectedCategory]);

  const allNews = newsQuery.data?.pages.flatMap(p => p.items) ?? [];

  return (
    <div className="min-h-screen">
      <TopBanner />
      <AppHeader
        selectedCategory={selectedCategory}
        setSelectedCategory={handleCategoryChange}
      />
      <main className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-8 sm:py-12">
        {selectedNews ? (
          <NewsDetail news={selectedNews} onBack={handleBack} />
        ) : (
          <NewsList
            news={allNews}
            loading={newsQuery.isLoading}
            loadingMore={newsQuery.isFetchingNextPage}
            hasMore={newsQuery.hasNextPage}
            error={newsQuery.error || undefined}
            onNewsClick={handleNewsClick}
            onRetry={newsQuery.refetch}
            onLoadMore={() => newsQuery.fetchNextPage()}
          />
        )}
      </main>
      <AppFooter />
    </div>
  );
}

export default App;

